// eslint-disable-next-line no-restricted-imports
import { LegalClientKnowledgeAndExperienceFragment } from 'api/generated/graphql';
import {
  EducationLevelType,
  LegalClientKnowledgeAndExperienceEntity,
  LegalClientFinancialInstrumentType,
} from 'api/types/entity';
import { lodash } from 'helpers';

export const parseLegalClientKnowledgeAndExperienceEntity = (
  data: LegalClientKnowledgeAndExperienceFragment
): LegalClientKnowledgeAndExperienceEntity => ({
  financialInstruments: data.financialInstruments
    ? lodash.compact(
        data.financialInstruments?.map(
          (v) => v && LegalClientFinancialInstrumentType[v]
        ) ?? null
      )
    : undefined,
  hasQualifiedOfficersForInvestmentDecisions:
    data.hasQualifiedOfficersForInvestmentDecisions,
  educationLevel: data.qualifiedOfficerForInvestmentDecision?.educationLevel
    ? EducationLevelType[
        data.qualifiedOfficerForInvestmentDecision?.educationLevel
      ]
    : undefined,
  heldFinancialPositionInLast5Years:
    data.qualifiedOfficerForInvestmentDecision
      ?.heldFinancialPositionInLast5Years ?? undefined,
  otherFinancialInstrument: data.otherFinancialInstrument ?? undefined,
});
